<template>
  <div id="visualizar-solicitacao" class="container column dados-da-solicitacao">
    <div class="logos print has-text-centered">
      <img
        src="../../assets/imagens/logo-relatorio-retrato.jpg"
        width="100%"
        alt="Logo AGEHAB/SEILOG"
      />
    </div>

    <div class="espacamento-interno visualizar-solicitacao" v-if="!loading">
      <div class="field-body-linha">
        <h2
          class="titulo titulo_grande u-margem-esquerda-pequena title is-5 print titulo-relatorios"
        >
          Solicitação de subsídio
        </h2>
        <h2
          class="titulo titulo_grande u-margem-inferior-pequena u-margem-esquerda-pequena title is-5 no-print titulo-relatorios"
        >
          Solicitação de subsídio
        </h2>
        <button
          type="button"
          onclick="window.print()"
          class="no-print botao botao_cor-terciaria botao_com-icone-para-direita botao_sem-preenchimento botao_medio"
        >
          <i class="fa fa-print" aria-hidden="true"></i>
          Imprimir
        </button>
      </div>
      <p class="texto-informativo">
        <span class="valor">
          Solicitação de Aporte de subsídio para aquisição da casa própria financiada nos
          termos do {{ artigoDaleiEstadual }} e {{ portariaNormativa }}.
        </span>
      </p>
      <div class="borda">
        <h2 class="titulo titulo_pequeno u-margem-inferior-media title is-5">
          Dados do(s) Proponente(s)
        </h2>
        <div v-for="(proponente, index) in proponentes">
          <span class="titulo titulo_pequeno"> {{ index + 1 }}º Proponente </span>
          <div class="field is-horizontal">
            <div class="field-body field-body-linha">
              <div class="field">
                <span class="label">
                  <strong>Nome:</strong>
                </span>
                <span>{{ proponente.Nome }}</span>
              </div>
              <div class="field">
                <span class="label">
                  <strong>CPF:</strong>
                </span>
                <span>{{ proponente.Cpf }}</span>
              </div>
              <div class="field">
                <span class="label">
                  <strong>Telefone:</strong>
                </span>
                <span>{{ proponente.Telefone || "NÃO INFORMADO" }}</span>
              </div>
              <div class="field">
                <span class="label">
                  <strong>Renda:</strong>
                </span>
                <span>{{ proponente.Renda || "NÃO INFORMADO" }}</span>
              </div>
            </div>
          </div>
          <div v-if="proponente.Conjuge">
            <span class="titulo titulo_pequeno">
              Cônjuge ({{ index + 1 }}º Proponente)
            </span>
            <div class="field is-horizontal">
              <div class="field-body field-body-linha">
                <div class="field">
                  <span class="label">
                    <strong>Nome:</strong>
                  </span>
                  <span>{{ proponente.Conjuge.Nome }}</span>
                </div>
                <div class="field">
                  <span class="label">
                    <strong>CPF:</strong>
                  </span>
                  <span>{{ proponente.Conjuge.Cpf }}</span>
                </div>
                <div class="field">
                  <span class="label">
                    <strong>Telefone:</strong>
                  </span>
                  <span>{{ proponente.Conjuge.Telefone || "NÃO INFORMADO" }}</span>
                </div>
                <div class="field">
                  <span class="label">
                    <strong>Renda:</strong>
                  </span>
                  <span>{{ proponente.Conjuge.Renda || "NÃO INFORMADO" }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="field-body field-body-linha">
          <div v-if="solicitacaoEhDoBonusMoradia" class="field">
            <span class="label">
              <strong>Renda familiar apurada:</strong>
            </span>
            <span>{{ rendaTotalComprovada || "NÃO INFORMADO" }}</span>
          </div>
          <div class="field">
            <span class="label">
              <strong>Somatório de renda:</strong>
            </span>
            <span>{{ rendaTotal || "NÃO INFORMADO" }}</span>
          </div>
        </div>
      </div>

      <div class="borda">
        <h2 class="titulo titulo_pequeno u-margem-inferior-media title is-5">
          Dados do Imóvel
        </h2>
        <div class="field is-horizontal">
          <div class="field-body field-body-linha">
            <div class="field">
              <span class="label">
                <strong>Construtora:</strong>
              </span>
              <span>{{ imovel.Empreendimento.Construtora.Nome }}</span>
            </div>
            <div class="field">
              <span class="label">
                <strong>CNPJ:</strong>
              </span>
              <span>{{ imovel.Empreendimento.Construtora.Cnpj }}</span>
            </div>
            <div class="field">
              <span class="label">
                <strong>Conta*:</strong>
              </span>
              <span>{{ imovel.Empreendimento.Construtora.Conta }}</span>
            </div>
          </div>
          <div class="field-body field-body-linha">
            <div class="field">
              <span class="label">
                <strong>Cidade:</strong>
              </span>
              <span>{{
                imovel.Endereco.Cidade.Nome + " - " + imovel.Endereco.Cidade.EstadoNome
              }}</span>
            </div>
            <div class="field">
              <span class="label">
                <strong>Tipo de Empreendimento:</strong>
              </span>
              <span>{{ imovel.Empreendimento.TipoDeEmpreendimento }}</span>
            </div>
            <div class="field">
              <span class="label">
                <strong>Nome do Empreendimento:</strong>
              </span>
              <span>{{ imovel.Empreendimento.Nome }}</span>
            </div>
          </div>
          <div class="field-body field-body-linha">
            <div class="field">
              <span class="label">
                <strong>Endereço:</strong>
              </span>
              <span>{{ imovel.EnderecoCompleto }}</span>
            </div>
          </div>
          <div class="field-body field-body-linha">
            <div class="field">
              <span class="label">
                <strong>Valor da compra e venda:</strong>
              </span>
              <span>{{ valorDaCompraEVenda }}</span>
            </div>
            <div class="field">
              <span class="label">
                <strong>Solicitação de aporte/subsídio da AGEHAB:</strong>
              </span>
              <span>{{ subsidioDaAgehab }}</span>
            </div>
          </div>
          <div class="field-body field-body-linha">
            <div class="field">
              <span class="label">
                <strong>Valor do financiamento concedido:</strong>
              </span>
              <span>{{ valorDoFinanciamentoAprovado }}</span>
            </div>
            <div v-if="solicitacaoEhDoBonusMoradia" class="field">
              <span class="label">
                <strong>Desconto da construtora na entrada:</strong>
              </span>
              <span>{{ descontoDaConstrutora }}</span>
            </div>
          </div>
          <div class="field-body field-body-linha">
            <div class="field">
              <span class="label">
                <strong>Valor do subsídio do Governo Federal:</strong>
              </span>
              <span>{{ subsidioDoGovernoFederal }}</span>
            </div>
            <div class="field">
              <span class="label">
                <strong
                  >Participação do proponente descontando subsídio e descontos:</strong
                >
              </span>
              <span>{{ participacaoDoSolicitante }}</span>
            </div>
          </div>
          <div class="field-body field-body-linha">
            <div v-if="!solicitacaoEhDoBonusMoradia" class="field">
              <span class="label">
                <strong>Valor do FGTS do proponente a utilizar:</strong>
              </span>
              <span>{{ fgtsDoSolicitante }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="declaracoes field">
        <p>
          *Conta de livre movimentação vinculada ao contrato de Apoio à Produção <br />
          *Conta indicada para a instituição Financeira para crédito dos valores do
          financiamento do imóvel
        </p>

        <h2
          class="titulo titulo_pequeno u-margem-inferior-media u-margem-superior-media title is-5 no-print"
        >
          Declarações
        </h2>
        <p>
          <span>(</span> <span>)</span> Declaro veracidade das informações acima
          prestadas, ciência e concordância com as condições estabelecidas na
          {{ portariaNormativa }} e estou ciente de que, se falsas as declarações, ficarei
          sujeito às penas da lei, ficando, ainda, obrigado(a) a devolver os valores
          indevidamente recebidos da AGEHAB a título do subsídio, acrescidos de correção
          monetária e juros.
        </p>
        <p>
          <span>(</span> <span>)</span> Declaro estar de posse da declaração do
          interessado que não foi atendido em outro programa habitacional, seja federal,
          estadual ou municipal, quando o benefício se trata de uma unidade habitacional
          completa, ou que seja proprietário de imóvel residencial.
        </p>
      </div>
      <div class="assinatura-container">
        <div class="area-assinatura">
          <div class="assinatura-linha"></div>
          <div class="label-assinatura">
            <strong>{{ usuarioSolicitanteNome }}</strong>
          </div>
        </div>
      </div>

      <router-link
        :to="{ name: 'ListaDeSolicitacoes' }"
        class="no-print botao botao_medio botao_cinza u-margem-direita-pequena"
        :class="{ 'is-disabled': loading.visivel }"
        >Voltar
      </router-link>
    </div>
    <loading :ativo="loading" :altura="'60px'" :largura="'60px'" />
  </div>
</template>

<script>
import Loading from "../shared/Loading";

export default {
  name: "visualizar-solicitacao",
  components: { Loading },
  filters: {
    upcase(data) {
      return data.toUpperCase();
    },
  },
  data() {
    return {
      portariaNormativa: "Portaria Normativa AGEHAB/MS nº 205, de 15 de março de 2024",
      artigoDaleiEstadual: "art. 4º da Lei Estadual nº 4.888 de 20 de julho de 2006",
      mensagemDeErro: null,
      mensagemDeErroDoCancelamento: null,
      proponentes: [],
      usuarioSolicitanteNome: null,
      financiamento: {},
      imovel: {},
      rendaTotal: null,
      valorDaCompraEVenda: null,
      valorDoFinanciamentoAprovado: null,
      subsidioDaAgehab: null,
      subsidioDoGovernoFederal: null,
      descontoDaConstrutora: null,
      fgtsDoSolicitante: null,
      participacaoDoSolicitante: null,
      loading: true,
      status: null,
      justificativa: "",
    };
  },
  beforeCreate() {
    this.loading = true;
    const idDaSolicitacao = this.$route.query.idDaSolicitacao;
    this.$api
      .get(`/solicitacao/${idDaSolicitacao}`)
      .then((response) => {
        const solicitacao = response.data;
        this.solicitante = solicitacao.Solicitante;
        this.proponentes = solicitacao.Proponentes;
        this.financiamento = solicitacao.Financiamento;
        this.imovel = solicitacao.Imovel;
        this.status = solicitacao.Status;
        this.usuarioSolicitanteNome = solicitacao.UsuarioSolicitanteNome;
        this.rendaTotal = this.$moeda.formatar(solicitacao.RendaTotal);
        this.valorDaCompraEVenda = this.$moeda.formatar(
          this.financiamento.ValorDaCompraEVenda
        );
        this.valorDoFinanciamentoAprovado = this.$moeda.formatar(
          this.financiamento.ValorDoFinanciamentoAprovado
        );
        this.subsidioDaAgehab = this.$moeda.formatar(this.financiamento.SubsidioDaAgehab);
        this.subsidioDoGovernoFederal = this.$moeda.formatar(
          this.financiamento.SubsidioDoGovernoFederal
        );
        this.fgtsDoSolicitante = this.$moeda.formatar(
          this.financiamento.FgtsDoSolicitante
        );
        this.participacaoDoSolicitante = this.$moeda.formatar(
          this.financiamento.ParticipacaoDoSolicitante
        );
        this.solicitacaoEhDoBonusMoradia = solicitacao.EhBonusMoradia;
        this.rendaTotalComprovada = this.$moeda.formatar(
          solicitacao.RendaTotalComprovada
        );
        this.descontoDaConstrutora = this.$moeda.formatar(
          this.financiamento.DescontoConstrutora
        );
        this.loading = false;
      })
      .catch((error) => {
        console.error(error);
      });
  },
};
</script>



// WEBPACK FOOTER //
// VisualizarSolicitacao.vue?8a05230e